// extracted by mini-css-extract-plugin
module.exports = {"spinner":"_3XqDv0mHgyIL5XBy7Krhic"};